import { Image, Container, Title, Text, Button, SimpleGrid } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import classes from './not-found.module.css';
import colors from '../../utils/styles';
export default function NotFound() {
  const navigate = useNavigate();
  return (  
    <Container size="responsive" className={classes.root}>
      <SimpleGrid spacing={{ base: 40, sm: 80 }} cols={{ base: 1, sm: 2 }}>
        <Image src='/assets/images/not_found.svg' className={classes.mobileImage} />
        <div>
          <Title className={classes.title} style={{ color: colors.appYellow }}>Something is not right...</Title>
          <Text c={colors.appWhite}>
            Page you are trying to open does not exist. You may have mistyped the address, or the
            page has been moved to another URL.
          </Text>
          <Button
            style={{ backgroundColor: colors.appPink, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)' }}
            onClick={() => navigate('/')} radius="xl" size="md" mt="xl" className={classes.control}>
            Back to home page
          </Button>
        </div>
      </SimpleGrid>
    </Container>
  );
}